<template>
  <div class="input-search-wrapper">
    <title-bar :title-stack="title || ''" />
    <div class="is-flex is-align-items-center flex-sm-column c-w-sm-100">
      <b-field class="c-w-sm-100 input-wrapper mr-3 mx-sm-0 input-search-global">
        <div class="search-icon">
          <SearchIcon color="#252525" width="16" height="16" />
        </div>
        <b-input
          placeholder="ID/Nama Toko/No. Invoice"
          type="search"
          v-model="keyword"
          @keyup.native.enter="handleSearch"
          class="search-wrapper input-none">
        </b-input>
      </b-field>
      <div class="is-flex is-align-items-center c-w-sm-100 flex-sm-wrap">
        <InputAutocomplete
          class="select-client all-ease-in-out mr-3 mr-sm-0 mb-sm-1 mt-sm-1"
          header="Pilih Client"
          imgKey="logo"
          :isVendor="true"
          :isNew="true"
          :haveImg="true"
          :onSelectItem="handleSelectVendor"
          :onClearSearch="handleSelectVendor"
        />

        <div class="paid-date" :class="{'active': isPaymentTab}">
          <DropdownDateSearchGlobal />
        </div>

        <div class="sort-and-search is-flex">
          <div class="dropdown-sort">
            <DropdownSortNewOld
              @clickedItem="onClickItem"
              @selected="sort = $event"
            />
          </div>

          <ButtonApp class="ml-3" :isSecondary="true" @click="handleSpecificSearch">
            <div class="flex-center-vertical" style="padding: 4px 0;">
              <SearchIcon color="#E10009" width="17" height="17" />
              <p class="averta-bold ml-1 is-hidden-mobile">Cari Lebih Spesifik</p>
            </div>
          </ButtonApp>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { alertErrorMessage } from '@/helpers'

export default {
  name: 'InputSearchGlobal',
  props: {
    title: {
      type: Array
    }
  },
  components: {
    TitleBar: () => import('@/components/TitleBar'),
    InputAutocomplete: () => import('@/components/input/InputAutocomplete.vue'),
    ButtonApp: () => import('@/components/button/ButtonApp.vue'),
    SearchIcon: () => import('@/components/icons/SearchIcon'),
    DropdownSortNewOld: () => import('@/components/dropdown/DropdownSortNewOld.vue'),
    DropdownDateSearchGlobal: () => import('@/components/dropdown/DropdownDateSearchGlobal.vue')
  },
  data () {
    return {
      keyword: '',
      sort: 'desc',
      vendor: null,
      isCurrentPage: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      listPersist: 'list/getPersistDataList',
      tabPersist: 'list/getPersistTabProject'
    }),
    isPaymentTab () {
      const item = this.tabPersist.countDataTabs[this.tabPersist.activeTab]
      if (item) {
        if (item.label === 'Pembayaran') {
          return true
        }
      }
      return false
    }
  },
  methods: {
    handleSelectVendor (props = {}) {
      const { dataVendor } = props
      if (dataVendor) {
        this.vendor = dataVendor.name
      } else {
        this.vendor = null
      }
      this.handleQuery()
    },
    onClickItem () {
      this.isCurrentPage = true
    },
    handleSearch () {
      if (!this.keyword) {
        return alertErrorMessage('Masukan Kata Kunci')
      }

      const body = {
        keyword: this.keyword,
        client: null,
        area: null,
        unit: null,
        building: null,
        start_date: null,
        end_date: null,
        type: null,
        status: null
      }

      if (this.vendor) {
        body.client = {
          name: this.vendor,
          code: this.vendor.toLowerCase().includes('summervil') ? 'SMRCN' : ''
        }
      }

      this.$store.commit('projectV2/setSpecificSearch', body)
      this.handleSpecificSearch()

      // const currentRole = this.user.roles[0].name
      // let routerPath = ''
      // switch (currentRole) {
      //   case 'Site Manager':
      //     routerPath = '/sm/search'
      //     break
      //   case 'Account Manager':
      //   case 'Business Support':
      //     routerPath = '/am/search'
      //     break
      //   case 'Purchasing':
      //     routerPath = '/purchasing/search'
      //     break
      //   default:
      //     routerPath = '/search'
      //     break
      // }

      // const payloadQuery = {
      //   keyword: this.keyword
      // }

      // if (this.sort) {
      //   payloadQuery.sort = this.sort
      // }
      // if (this.vendor) {
      //   payloadQuery.vendor = this.vendor
      // }

      // this.$router.push({ path: routerPath, query: payloadQuery })
    },
    handleQuery () {
      const payloadQuery = {}

      if (this.sort) {
        payloadQuery.sort = this.sort
      }
      if (this.vendor) {
        payloadQuery.vendor = this.vendor
      }

      this.$store.commit('project/setDataListFilter', payloadQuery)
      this.$router.replace({ query: payloadQuery })
    },
    handleSpecificSearch () {
      const currentRole = this.user.roles[0].name

      let path = ''
      switch (currentRole) {
        case 'Site Manager':
          path = '/sm/specific-search'
          break
        case 'Account Manager':
        case 'Business Support':
          path = '/am/specific-search'
          break
        case 'Purchasing':
          path = '/purchasing/specific-search'
          break
        default:
          path = '/specific-search'
          break
      }
      this.$router.push({ path })
    }
  },
  watch: {
    sort () {
      if (!this.listPersist.detailPage || this.isCurrentPage) {
        const queryParams = this.$route.query
        if (queryParams.vendor) {
          this.vendor = queryParams.vendor
        }
        this.handleQuery()
      }
    },
    isPaymentTab (val) {
      if (window.matchMedia('screen and (max-width: 768px)').matches) {
        const inputClient = document.querySelector('.select-client')
        const paidDate = document.querySelector('.paid-date')
        const sort = document.querySelector('.sort-and-search')
        if (val) {
          inputClient.style.setProperty('width', '100%', 'important')
          paidDate.style.setProperty('width', '48%', 'important')
          sort.style.setProperty('width', 'calc(48% - 10px)', 'important')
          sort.style.setProperty('margin-left', '0px', 'important')
        } else {
          inputClient.style.setProperty('width', '45%', 'important')
          paidDate.style.setProperty('width', '13em', 'important')
          sort.style.setProperty('width', 'calc(55% - 10px)', 'important')
          sort.style.setProperty('margin-left', '10px', 'important')
        }
      }
    },
    '$route.query': {
      immediate: true,
      handler (newQuery, oldQuery) {
        if (!oldQuery) {
          if (JSON.stringify(newQuery) !== JSON.stringify(oldQuery)) {
            this.sort = newQuery.sort || 'desc'
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.input-search-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 95%;
  margin: auto;
  margin-top: 0.5em;
  margin-bottom: 2.5em;
  position: relative;
}

.search-wrapper {
  width: 14em;
}

.input-wrapper {
  border: 1px solid #E1E1E1;
  border-radius: 5px;
  margin-bottom: 0;
  position: relative;
}

.search-icon {
  position: absolute;
  z-index: 10;
  top: 7px;
  left: 7px;
}

.paid-date {
  width: 13em;
  margin-right: -13em;
  opacity: 0;
  transition: all 0.3s ease-in-out;
  position: relative;

  &.active {
    opacity: 1;
    margin-right: 0.75rem !important;
  }
}

@media only screen and (max-width: 600px) {
  .input-search-wrapper {
    flex-direction: column;
    margin-bottom: 0.5em;
    width: 100%;
  }

  .search-wrapper {
    width: 100%;
  }

  .select-client {
    width: 45% !important;
  }

  .dropdown-sort {
    width: 90%;
  }

  .sort-and-search {
    width: calc(55% - 10px);
  }
}
</style>

<style>
.input-search-global input {
  font-size: 14px;
  padding-left: 29px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

.input-search-global .icon.is-left {
  left: -3px !important;
  top: -2px;
}
</style>
